import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { taskDataCalc, taskSourcesCalc } from '../../utils/taskCalc';

import {
    WhiteMan as WhiteSource,
    RedMan as RedSource,
    GreenMan as GreenSource,
    DiamondSm,
} from '../../Constants/assets';

const TaskNameCheckbox = styled.form`
    height: 30%;
`;
const Input = styled.input`
    width: 20px;
    height: 20px;
    border-radius: 3px;
    cursor: pointer;
    :checked {
        background: ${props => props.theme.colors.darkGreen};
    }
`;
const Label = styled.label`
    font-style: normal;
    font-weight: 500;
    font-size: 1.1rem;
    line-height: 1.375rem;
    margin-left: 15px;
`;
const TaskDescription = styled.div`
    display: flex;
    justify-content: space-between;
    width: 67%;
    height: 70%;
    margin-left: 36px;
`;
const DetailTitle = styled.div`
    font-weight: normal;
    font-size: 0.75rem;
    line-height: 0.875rem;
    color: ${props => props.theme.colors.gray};
`;
const DetailSubTitle = styled.div`
    font-weight: 500;
    font-size: 1.313rem;
    line-height: 1.563rem;
`;
// TODO: Fix this, this is temporary fix
export default function TaskItem({ value, handleIsChecked, originTaskArray }) {
    const { t } = useTranslation();
    const tasksIds = originTaskArray.map(current => current.taskIdnumberInDB);
    return (
        <>
            <TaskNameCheckbox>
                {/* <Input type="checkbox" class="checkbox" onChange={() => handleIsChecked()} /> */}
                {/* Temporary until it will work */}
                <Label>
                    {t(`project_sheet.project_scope.tasks.${value[0].id}.task_title`, {
                        taskId: value[0].id,
                    })}
                    &nbsp; | #{tasksIds.indexOf(value[0].id) + 1}
                </Label>
            </TaskNameCheckbox>
            <TaskDescription>
                <div>
                    <DetailTitle>{t(`global_variables.cost`)}</DetailTitle>
                    <DetailSubTitle>${value[0].costMoney}</DetailSubTitle>
                </div>
                <div>
                    <DetailTitle>{t(`global_variables.resources.resources`)}</DetailTitle>
                    <DetailSubTitle style={{ fontSize: '0.875rem' }}>
                        <WhiteSource /> {value[0].costResourcesNormal} &nbsp;
                        <RedSource /> {value[0].costResourcesSenior} &nbsp;
                        <GreenSource /> {value[0].costResourcesExpensive}
                    </DetailSubTitle>
                </div>{' '}
                <div>
                    <DetailTitle>{t(`global_variables.value`)}</DetailTitle>
                    <DetailSubTitle>
                        {value[0].valueChange} &nbsp; <DiamondSm />{' '}
                    </DetailSubTitle>
                </div>{' '}
            </TaskDescription>
        </>
    );
}
